(function () {
  'use strict';

  var MAPBOX_GEOCODE_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';
  var MAP_STYLE = 'mapbox://styles/mapbox/light-v11';

  function init() {
    var root = document.querySelector('.slp-locator');
    if (!root) return;

    var dataEl = root.querySelector('.slp-locator__data');
    var stores = [];
    if (dataEl) {
      try { stores = JSON.parse(dataEl.textContent) || []; } catch (e) { stores = []; }
    }
    stores = stores.filter(function (s) { return s && s.name; });
    stores.forEach(function (s, i) {
      s.__id = 's_' + i;
      s.lat = parseFloat(s.lat);
      s.lng = parseFloat(s.lng);
    });

    var token = root.getAttribute('data-mapbox-token') || '';
    var defaultLat = parseFloat(root.getAttribute('data-default-lat'));
    var defaultLng = parseFloat(root.getAttribute('data-default-lng'));
    var defaultZoom = parseFloat(root.getAttribute('data-default-zoom'));
    var chainLogos = {
      delhaize: root.getAttribute('data-logo-delhaize') || ''
    };

    function chainLogoUrl(name) {
      if (!name) return '';
      if (/delhaize/i.test(name) && chainLogos.delhaize) return chainLogos.delhaize;
      return '';
    }
    if (isNaN(defaultLat)) defaultLat = 50.85;
    if (isNaN(defaultLng)) defaultLng = 4.35;
    if (isNaN(defaultZoom)) defaultZoom = 7;

    var listEl = root.querySelector('.slp-locator__list');
    var emptyEl = root.querySelector('.slp-locator__empty');
    var searchInput = root.querySelector('.slp-locator__search-input');
    var searchBtn = root.querySelector('.slp-locator__search-btn');
    var clearBtn = root.querySelector('.slp-locator__search-clear');
    var geoBtn = root.querySelector('.slp-locator__geolocate');
    var statusEl = root.querySelector('.slp-locator__status');
    var tabs = root.querySelectorAll('.slp-locator__tab');
    var listPanel = root.querySelector('.slp-locator__list-panel');
    var mapPanel = root.querySelector('.slp-locator__map-panel');
    var mapEl = root.querySelector('.slp-locator__map');

    var origin = null;
    var map = null;
    var markers = [];
    var debounceTimer = null;

    function haversine(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var toRad = function (d) { return (d * Math.PI) / 180; };
      var dLat = toRad(lat2 - lat1);
      var dLng = toRad(lng2 - lng1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function formatDistance(km) {
      if (km == null || isNaN(km)) return '';
      if (km < 1) return Math.round(km * 1000) + ' m';
      if (km < 10) return km.toFixed(1) + ' km';
      return Math.round(km) + ' km';
    }

    function escapeHtml(s) {
      if (s == null) return '';
      return String(s).replace(/[&<>"']/g, function (m) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
      });
    }

    function safeUrl(u) {
      if (!u) return '';
      var s = String(u).trim();
      if (/^javascript:/i.test(s)) return '';
      return s;
    }

    function directionsUrl(s) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
    }

    function sortStores() {
      var copy = stores.slice();
      copy.sort(function (a, b) {
        if (origin) {
          a.__dist = haversine(origin.lat, origin.lng, a.lat, a.lng);
          b.__dist = haversine(origin.lat, origin.lng, b.lat, b.lng);
        }
        if (a.featured !== b.featured) return a.featured ? -1 : 1;
        if (origin) return a.__dist - b.__dist;
        return (a.city || '').localeCompare(b.city || '', 'nl');
      });
      return copy;
    }

    function renderList() {
      if (!listEl) return;
      var sorted = sortStores();
      if (!sorted.length) {
        listEl.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }
      if (emptyEl) emptyEl.style.display = 'none';

      listEl.innerHTML = sorted.map(function (s) {
        var dist = origin ? formatDistance(s.__dist) : '';
        var addr2 = s.address2 ? '<span class="slp-locator__card-line">' + escapeHtml(s.address2) + '</span>' : '';
        var notes = s.notes ? '<div class="slp-locator__card-notes">' + escapeHtml(s.notes) + '</div>' : '';
        var phoneClean = s.phone ? s.phone.replace(/\s+/g, '') : '';
        var phone = s.phone ? '<a class="slp-locator__card-meta" href="tel:' + escapeHtml(phoneClean) + '">' + escapeHtml(s.phone) + '</a>' : '';
        var img = s.image ? '<img class="slp-locator__card-img" src="' + escapeHtml(s.image) + '" alt="' + escapeHtml(s.name) + '" loading="lazy">' : '';
        var star = s.featured ? '<span class="slp-locator__card-star" aria-label="Uitgelicht">&#9733;</span>' : '';
        var logo = chainLogoUrl(s.name);
        var logoHtml = logo ? '<img class="slp-locator__card-logo" src="' + escapeHtml(logo) + '" alt="" loading="lazy">' : '';
        return (
          '<article class="slp-locator__card' + (s.featured ? ' is-featured' : '') + '" data-store-id="' + s.__id + '">' +
            logoHtml +
            img +
            '<div class="slp-locator__card-body">' +
              '<header class="slp-locator__card-head">' +
                '<h3 class="slp-locator__card-title">' + star + escapeHtml(s.name) + '</h3>' +
                (dist ? '<span class="slp-locator__card-dist">' + dist + '</span>' : '') +
              '</header>' +
              '<div class="slp-locator__card-addr">' +
                '<span class="slp-locator__card-line">' + escapeHtml(s.address) + '</span>' +
                addr2 +
                '<span class="slp-locator__card-line">' + escapeHtml(s.postal) + ' ' + escapeHtml(s.city) + '</span>' +
              '</div>' +
              notes +
              '<div class="slp-locator__card-actions">' +
                '<a class="slp-locator__card-cta" href="' + directionsUrl(s) + '" target="_blank" rel="noopener">Routebeschrijving &rarr;</a>' +
                phone +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }).join('');
    }

    function activateStore(id, scrollCard) {
      if (!listEl) return;
      var cards = listEl.querySelectorAll('.slp-locator__card');
      cards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-store-id') === id);
      });
      if (scrollCard) {
        var active = listEl.querySelector('.slp-locator__card.is-active');
        if (active) active.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      markers.forEach(function (m) {
        m.pin.classList.toggle('is-active', m.id === id);
      });
      if (map) {
        var s = stores.find(function (x) { return x.__id === id; });
        if (s && !isNaN(s.lat) && !isNaN(s.lng)) {
          map.flyTo({ center: [s.lng, s.lat], zoom: 13, speed: 1.2 });
          var entry = markers.find(function (m) { return m.id === id; });
          if (entry) {
            markers.forEach(function (m) { if (m !== entry && m.popup.isOpen()) m.marker.togglePopup(); });
            if (!entry.popup.isOpen()) entry.marker.togglePopup();
          }
        }
      }
    }

    if (listEl) {
      listEl.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var card = e.target.closest('.slp-locator__card');
        if (!card) return;
        var id = card.getAttribute('data-store-id');
        activateStore(id, false);
        if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
          switchTab('map');
        }
      });
    }

    function switchTab(name) {
      tabs.forEach(function (t) {
        var active = t.getAttribute('data-tab') === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (name === 'map') {
        if (listPanel) listPanel.classList.remove('is-active');
        if (mapPanel) mapPanel.classList.add('is-active');
        ensureMap();
      } else {
        if (mapPanel) mapPanel.classList.remove('is-active');
        if (listPanel) listPanel.classList.add('is-active');
      }
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { switchTab(t.getAttribute('data-tab')); });
    });

    function pinHtml(featured) {
      var inner = featured
        ? '<path d="M16 9.5l1.6 3.2 3.5.5-2.5 2.4.6 3.5-3.2-1.7-3.2 1.7.6-3.5-2.5-2.4 3.5-.5z" fill="#FFFFFF"/>'
        : '<circle cx="16" cy="14" r="4" fill="#FFFFFF"/>';
      return (
        '<svg width="32" height="40" viewBox="0 0 32 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M16 1c-7 0-13 5.4-13 12.4 0 9 13 25.6 13 25.6s13-16.6 13-25.6C29 6.4 23 1 16 1z" fill="#F19323" stroke="#FFFFFF" stroke-width="2"/>' +
          inner +
        '</svg>'
      );
    }

    function placePins() {
      markers.forEach(function (m) { m.marker.remove(); });
      markers = [];
      if (!window.mapboxgl || !map) return;
      stores.forEach(function (s) {
        if (isNaN(s.lat) || isNaN(s.lng) || (s.lat === 0 && s.lng === 0)) return;
        var pin = document.createElement('div');
        pin.className = 'slp-locator__pin' + (s.featured ? ' is-featured' : '');
        pin.innerHTML = pinHtml(!!s.featured);
        pin.addEventListener('click', function (e) {
          e.stopPropagation();
          activateStore(s.__id, true);
        });
        var popupHtml =
          '<div class="slp-locator__popup">' +
            '<strong>' + escapeHtml(s.name) + '</strong><br>' +
            escapeHtml(s.address) + '<br>' +
            escapeHtml(s.postal) + ' ' + escapeHtml(s.city) +
            '<br><a href="' + directionsUrl(s) + '" target="_blank" rel="noopener">Routebeschrijving &rarr;</a>' +
          '</div>';
        var popup = new window.mapboxgl.Popup({ offset: 30, closeButton: true }).setHTML(popupHtml);
        var marker = new window.mapboxgl.Marker({ element: pin, anchor: 'bottom' })
          .setLngLat([s.lng, s.lat])
          .setPopup(popup)
          .addTo(map);
        markers.push({ id: s.__id, marker: marker, popup: popup, pin: pin });
      });
    }

    function ensureMap() {
      if (map) {
        setTimeout(function () { try { map.resize(); } catch (e) {} }, 60);
        return;
      }
      if (!window.mapboxgl) {
        // Mapbox SDK loaded async with defer; retry shortly.
        setTimeout(ensureMap, 200);
        return;
      }
      if (!token) {
        if (statusEl) statusEl.textContent = 'Mapbox-token ontbreekt — voeg het toe via de theme editor.';
        return;
      }
      window.mapboxgl.accessToken = token;
      map = new window.mapboxgl.Map({
        container: mapEl,
        style: MAP_STYLE,
        center: [defaultLng, defaultLat],
        zoom: defaultZoom,
        attributionControl: true,
        cooperativeGestures: false
      });
      map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
      map.on('load', function () {
        placePins();
        if (origin) map.flyTo({ center: [origin.lng, origin.lat], zoom: 11, speed: 1.2 });
      });
    }

    function doGeocode(query) {
      if (!query) return;
      if (!token) {
        if (statusEl) statusEl.textContent = 'Mapbox-token ontbreekt — voeg het toe via de theme editor.';
        return;
      }
      if (statusEl) statusEl.textContent = 'Zoeken…';
      var url = MAPBOX_GEOCODE_URL + encodeURIComponent(query) + '.json' +
        '?access_token=' + encodeURIComponent(token) +
        '&country=be,nl&limit=1&language=nl';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.features || !data.features.length) {
            if (statusEl) statusEl.textContent = 'Geen resultaat voor "' + query + '"';
            return;
          }
          var f = data.features[0];
          origin = { lat: f.center[1], lng: f.center[0] };
          if (statusEl) statusEl.textContent = 'Dichtstbijzijnde winkels bij ' + (f.place_name_nl || f.place_name || query);
          renderList();
          if (clearBtn) clearBtn.style.display = '';
          if (map) map.flyTo({ center: [origin.lng, origin.lat], zoom: 11, speed: 1.2 });
        })
        .catch(function () {
          if (statusEl) statusEl.textContent = 'Zoekopdracht mislukt — probeer opnieuw.';
        });
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', function () { doGeocode(searchInput.value.trim()); });
    }
    if (searchInput) {
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          clearTimeout(debounceTimer);
          doGeocode(searchInput.value.trim());
        }
      });
      searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = searchInput.value.trim();
        if (!q) {
          origin = null;
          if (statusEl) statusEl.textContent = '';
          if (clearBtn) clearBtn.style.display = 'none';
          renderList();
          return;
        }
        debounceTimer = setTimeout(function () { doGeocode(q); }, 600);
      });
    }
    if (clearBtn) {
      clearBtn.style.display = 'none';
      clearBtn.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        origin = null;
        if (statusEl) statusEl.textContent = '';
        clearBtn.style.display = 'none';
        renderList();
      });
    }

    if (geoBtn) {
      geoBtn.addEventListener('click', function () {
        if (!navigator.geolocation) {
          if (statusEl) statusEl.textContent = 'Locatie wordt niet ondersteund door deze browser.';
          return;
        }
        if (statusEl) statusEl.textContent = 'Locatie ophalen…';
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            origin = { lat: pos.coords.latitude, lng: pos.coords.longitude };
            if (statusEl) statusEl.textContent = 'Dichtstbijzijnde winkels bij jouw locatie';
            renderList();
            if (map) map.flyTo({ center: [origin.lng, origin.lat], zoom: 11, speed: 1.2 });
          },
          function () {
            if (statusEl) statusEl.textContent = 'Locatie geweigerd of niet beschikbaar.';
          },
          { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }
        );
      });
    }

    renderList();

    // On desktop the map panel is always visible — init proactively after first paint.
    if (window.matchMedia && !window.matchMedia('(max-width: 900px)').matches) {
      ensureMap();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
